<template>
  <div class="smartz-events-page chart-content">
    <div>
      <div ref="print">
        <div class="page-card-wrapper">
          <div class="page-card-title">
            <div
              class="left-side-text"
              v-if="$store.state.patient.selectedPatient"
            >
              {{ $store.state.patient.selectedPatient.alias }}
              <span v-if="$store.state.patient.selectedPatient.podMac"
                >({{
                  $store.state.patient.selectedPatient.podMac.substr(-4)
                }})</span
              >
            </div>
            <span
              class="page-card-title-text"
              v-html="$t('text.events').toUpperCase()"
            ></span>
            <DateRangePicker />
          </div>
          <div class="page-card-content">
            <PrintSection
              :chartData="chartData"
              :loading="loading"
              :timeIconActive="timeIconActive"
            />
            <div class="time-location-text">
              {{ $t('text.all_times_are_in') }} {{ location || '--' }}
            </div>
            <ChartFilter ref="chartFilter" @updateData="getData()" />
          </div>
        </div>
      </div>
      <div class="action-btns mt-20">
        <div
          class="action-btn"
          @click="share()"
          v-if="p('Patients.Charts.Event.Share')"
        >
          <svg-icon
            iconClass="share"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.share') }}</span>
        </div>
        <div
          class="action-btn"
          @click="print()"
          v-if="p('Patients.Charts.Event.Print')"
        >
          <svg-icon
            iconClass="report"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.print') }}</span>
        </div>
      </div>
    </div>
    <ShareDialog ref="shareDialog" />
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import ShareDialog from '@/components/patients/charts/ShareDialog'
import { images, voidState, hours } from '@/const.js'
import DateRangePicker from '@/components/patients/charts/DateRangePicker'
import PrintSection from '@/components/patients/charts/smartzEventsChart/PrintSection'
import ChartFilter from '@/components/patients/charts/smartzEventsChart/ChartFilter'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import $ from 'jquery'
import swal from 'sweetalert'
import { smartzEventConst } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
export default {
  data() {
    return {
      images,
      voidState,
      moment,
      userLang: navigator.language || navigator.userLanguage,
      hours: hours,
      chartData: [],
      loading: false,
      location: null,
      timeIconActive: false
    }
  },
  components: {
    ShareDialog,
    DateRangePicker,
    PrintSection,
    ChartFilter
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getData()
    },
    '$store.state.patient.selectedDateRange': function() {
      this.getData()
    }
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    subject() {
      return this.$t('text.events')
    },
    selectedFilter() {
      return this.$refs.chartFilter.selectedFilter
    }
  },
  methods: {
    getData() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.loading = true
      ApiService.GetPatientEventRecord(
        this.$store.state.patient.selectedPatient.patientId,
        moment(this.$store.state.patient.selectedDateRange[0]).format(
          'YYYY-MM-DD'
        ),
        moment(this.$store.state.patient.selectedDateRange[1]).format(
          'YYYY-MM-DD'
        )
      )
        .then(response => {
          this.loading = false
          if (
            typeof response.data === 'string' &&
            response.data.includes('- demo')
          ) {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.replace('- demo', '')
            })
            return false
          }
          this.location = response.data.data.Location
          this.getNightTime(
            response.data.data.nightTimeStart,
            response.data.data.nightTimeEnd
          )

          // only show the events selected by the user
          this.chartData = response.data.data.eventData.map(item => {
            return {
              ...item,
              Events: item.Events.filter(eventItem => eventItem.Status).filter(
                eventItem => {
                  let statusArr = [
                    smartzEventConst.clumpedGreen,
                    smartzEventConst.clumpedYellow,
                    smartzEventConst.checkBin
                  ].includes(eventItem.Status)
                    ? [eventItem.Status]
                    : eventItem.Status.split('-')
                  return this.selectedFilter.includes(statusArr[0])
                }
              )
            }
          })
        })
        .catch(() => {
          this.loading = false
          this.chartData = []
          swal({
            icon: 'error',
            title: this.$t('text.failed'),
            text: this.$t('text.failed_to_get_chart_data')
          })
        })
    },
    // Dynamically determine the nighttime time range
    getNightTime(nightTimeStart, nightTimeEnd) {
      nightTimeStart =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeStart.split('.')[0]
      nightTimeEnd =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeEnd.split('.')[0]
      const isCrossDay = moment(nightTimeStart).isAfter(nightTimeEnd)
      this.hours.forEach(hour => {
        const hourValue = moment().format('YYYY-MM-DD') + ' ' + hour.value
        // Consider whether the night time is short or not
        if (isCrossDay) {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) ||
            moment(hourValue).isBefore(nightTimeEnd)
        } else {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) &&
            moment(hourValue).isBefore(nightTimeEnd)
        }
      })
      this.timeIconActive = isCrossDay
    },
    share() {
      this.$refs.shareDialog.openDialog('smartz_events')
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: doc => {
          $(doc)
            .find('body')
            .css('width', '2200px')
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find('.new-design .smartz-events-page .legend')
            .css('width', '100%')
            .css('display', 'flex')
          $(doc)
            .find(
              '.new-design .smartz-events-page .legend .legend-title,  .new-design .smartz-events-page .legend .legend-group'
            )
            .css('margin-right', '80px')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .left-side-text'
            )
            .css('display', 'inline-block')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
        }
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image'
        })
      })
    }
  }
}
</script>
